

import { useState } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  TextField,
  Button,
  Autocomplete,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { Menu as MenuIcon, Add as AddIcon, Person as PersonIcon } from "@mui/icons-material"
import { useAuth } from "../../contexts/AuthContext"
import { Link } from "react-router-dom";

function TopBar({ onMenuClick }) {
  const { user, logout } = useAuth()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - 280px)` },
        ml: { sm: `280px` },
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: 2 }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Logo and App Name */}
        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Typography variant="h6" noWrap component="div" sx={{ fontWeight: "bold" }}>
            Fiscale
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 1 }}>
          {!isMobile && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                color="inherit"
                startIcon={<PersonIcon />}
                to="/add-client"
                component={Link}
                variant="outlined"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.3)",
                  "&:hover": {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                  },
                }}
              >
                Add Client
              </Button>
              <Button
                component={Link}
                color="inherit"
                startIcon={<AddIcon />}
                variant="outlined"
                to="/add-job"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.3)",
                  "&:hover": {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                  },
                }}
              >
                Add Job
              </Button>
            </Box>
          )}

          {/* User Info */}
          <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
            <Typography variant="body2" sx={{ mr: 1 }}>
              {user?.name} ({user?.role})
            </Typography>
            <Button color="inherit" onClick={logout} size="small">
              Logout
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default TopBar
